import { Link } from "gatsby"
import * as React from "react"
import { Helmet } from "react-helmet"
import svgPath from '../../images/scroll_top.svg'
import favicon from '../../images/favicon-2015.ico'
import './css/roboto.css'
import './css/style.css'

const scrollToTop = (e) => {
  e.preventDefault()
  window.scrollTo(0, 0)
  return false
}

const Layout = ({ children, fluid }) => {
  React.useEffect(() => {
    window.addEventListener('scroll', function(e) {
      const toTopButton = document.querySelector('#scroll_top')
      if(window.scrollY > 100) {
        toTopButton.style.visibility = 'visible'
      } else {
        toTopButton.style.visibility = 'hidden'
      }
    })
  }, [])

  return (
    <div className="instruction">
      <Helmet>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta http-equiv="X-UA-Compatible" content="ie=edge" />
        <link rel="shortcut icon" href={favicon} />
        <title>Инструкция по регистрации в СЭО МАИ</title>
      </Helmet>
      <header>
        <h2 className="instruction__heading instruction__heading_h2"><Link to="/">Инструкция</Link></h2>
        <a className="link-arrow" rel="noreferrer" href="https://lms.mai.ru" target="_blank">
          <span className="circle" aria-hidden="true">
          <span className="icon arrow"></span>
          </span>
          <span className="button-text">lms.mai.ru</span>
        </a>
        <a className="link-arrow" rel="noreferrer" href="https://mai.ru" target="_blank">
          <span className="circle" aria-hidden="true">
          <span className="icon arrow"></span>
          </span>
          <span className="button-text">mai.ru</span>
        </a>
      </header>
      <main className={fluid ? 'container-fluid' : 'container'}>
        {children}
      </main>
      <button style={{backgroundImage: `url(${svgPath})`}} id="scroll_top" title="Наверх" aria-label="scroll to top" onClick={scrollToTop}></button>
    </div>
  )
}

export default Layout